import React, { useState, useEffect } from "react";
import "../../css/BotonExpandible.css";
import importante from "../../assets/importante.svg";

const BotonImportante = ({ mensaje }) => {
  const [expandido, setExpandido] = useState(true);
  const [mostrarEnfasis, setMostrarEnfasis] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setExpandido(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

//   useEffect(() => {
//     const enfasisTimeout = setTimeout(() => {
//       setMostrarEnfasis(false);
//     }, 1500);
//     return () => clearTimeout(enfasisTimeout);
//   }, []);

  const manejarClick = () => {
    setExpandido(!expandido);
    setMostrarEnfasis(false);
  };

  return (
    <div 
      className={`boton-aviso ${expandido ? "expandido" : "colapsado"} ${
        expandido && mostrarEnfasis ? "enfasis" : ""
      }`}
    //   onClick={() => setExpandido(!expandido)}
      onClick={() => manejarClick()}
    >
      <span className="icono">
        <img
          src={importante}
          className={`acuerdogeneral-btn-logop ${!expandido ? "icono-blanco" : ""}`}
          alt="icono importante"
        />
      </span>

      {expandido ? (
        <div className="mensaje">
          {mensaje}          
        </div>
      ) : (
        <span className="texto-colapsado">IMPORTANTE</span>
      )}
    </div>
  );

};

export default BotonImportante;

